import(/* webpackMode: "eager" */ "/vercel/path0/src/app/cancellation-and-refund-policy/page.js")